import { AxiosHeaders, AxiosRequestHeaders } from 'axios'
import { useContext } from 'react'
import { UseQueryOptions } from '@tanstack/react-query'
import router from 'next/router'

import { AuthorizationContext } from 'src/shared/context'
import { IAuthor } from 'src/shared/api/typing'

import { useQueryHook } from './queryHook'
import { apiGet } from '../axios.config'
import { API_ROUTES } from '../routes'

export const useGetDataAuthor = (options?: Omit<UseQueryOptions<IAuthor>, 'queryKey' | 'queryFn'>) => {
  const { token, setToken } = useContext(AuthorizationContext)
  const path = API_ROUTES.AUTHOR_GET

  const queryObject = useQueryHook({
    key: [path, token],
    fetcherFunction: async () => {
      try {
        const headers = new AxiosHeaders({
          Authorization: `Bearer ${token}`,
        })

        const { data } = await apiGet<AxiosRequestHeaders, IAuthor>({ path, headers })

        return data
      } catch (error: any) {
        if (error.response?.status === 401) {
          setToken('')
          router.push('/')
        }
        throw error
      }
    },
    options,
  })

  if (queryObject.isLoading || queryObject.isError) {
    return {
      ...queryObject,
      data: null,
    }
  }

  return {
    ...queryObject,
    data: queryObject.data as IAuthor | null,
  }
}
